export function styleMapDirections() {

    let heightDirections = ( $('.map .directions').height() )/2 + 75;
    $('.map .directions').css({ 'bottom': 'calc(50% + ' + heightDirections+ 'px)' });
    
}

export function addPlaceholder() {

    $('#wpsl-search-input').attr("placeholder", "Zip code");
    
}